import { fetchMembers } from '@/lib/blocks/api';
import type { MemberRecord } from '@/lib/blocks/types';

let cachedMap: Map<string, MemberRecord> | null = null;

export async function getMemberDisplayMap(): Promise<Map<string, string>> {
  if (!cachedMap) {
    const members = await fetchMembers();
    cachedMap = new Map(members.map((member) => [member.id, member]));
  }

  const labels = new Map<string, string>();
  for (const [id, member] of cachedMap) {
    labels.set(id, member.displayName);
  }
  return labels;
}

export function clearMemberDisplayCache(): void {
  cachedMap = null;
}
